import { apiUrl } from 'config';
import axios from '../_helpers/axios';
import { router } from '@/_helpers/router';

export const userService = {
  clientLogin,
  neoLogin,
  logout,
};

async function clientLogin(username, password) {
  return await axios
    .post(`${apiUrl}/authenticate`, { username, password })
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user));
      }
      return user;
    })
    .catch(err => {
      return {error: err?.response?.data?.error || err}
    })
}


function neoLogin(googleUser) {
  return axios.post(`${apiUrl}/googleauth`, {...googleUser,app_id:'app_compass'})
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user.email_verified) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user));
        return user;
      } else {
        throw 'Email is not registered';
      }
    })
    .catch(error => {
      if (error?.response?.data?.error?.errorCode==='APP_ACCESS_RESTRICTED') {
        router.push('/auth-error');
      }
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
}
